module.exports = __webpack_public_path__ + "img/img9.651edb10.png";